import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-white">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-fire-fill text-xl text-primary-400"></i>
                </div>
                <span className="font-heading font-bold text-xl">51暗网吃瓜</span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed max-w-xs">
                {t("footer.disclaimer")}
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-base mb-5">快速导航</h4>
              <nav className="flex flex-col gap-3">
                <Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  {t("nav.home")}
                </Link>
                <Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  网红塌房
                </Link>
                <Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  明星爆料
                </Link>
                <Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  每日大赛
                </Link>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  {t("nav.about")}
                </Link>
              </nav>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-base mb-5">热点标签</h4>
              <div className="flex flex-wrap gap-2">
                {["小杨哥", "直播翻车", "顶流恋爱", "导演潜规则", "税务问题", "网红塌房", "女团恋情", "美食博主"].map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full text-xs bg-white/10 text-foreground-200 hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-base mb-5">{t("footer.contact")}</h4>
              <div className="flex flex-col gap-3 text-sm text-foreground-300">
                <p>联系邮箱：hello@hnwmjg.cn</p>
                <p>微信公众号：51暗网吃瓜</p>
                <p>官方QQ群：88888888</p>
              </div>
              <div className="flex items-center gap-4 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-base"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              {t("footer.copyright")}
            </p>
            <div className="flex items-center gap-6">
              <Link to="/about" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                {t("footer.privacy")}
              </Link>
              <Link to="/about" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                {t("footer.terms")}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="relative overflow-hidden h-20 bg-background-950/50">
        <div className="absolute bottom-0 left-0 right-0 flex items-end justify-center opacity-[0.04] pointer-events-none select-none">
          <span className="font-heading font-black text-[120px] leading-none whitespace-nowrap">
            51暗网吃瓜
          </span>
        </div>
      </div>
    </footer>
  );
}